/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M505.261 62.82c0-11.776-9.557-21.305-21.333-21.305h-.028c-11.776 0-21.305 9.557-21.305 21.361l.085 81.807C421.492 67.115 339.402 16 248.806 16 115.487 16 7 123.861 7 256.44c0 132.58 108.487 240.442 241.806 240.442 96.37 0 183.467-56.804 221.867-144.726 4.722-10.808-.228-23.38-11.037-28.103-10.695-4.636-23.352.228-28.074 11.008-31.602 72.391-103.367 119.154-182.756 119.154-109.795 0-199.14-88.718-199.14-197.774s89.345-197.774 199.14-197.774c76.345 0 145.294 44.032 178.375 110.307l-74.894-12.06c-11.577-2.048-22.585 6.002-24.434 17.664-1.905 11.634 6.03 22.585 17.664 24.462l135.168 21.76c1.138.2 2.247.284 3.385.284 5.035 0 9.927-1.792 13.824-5.091a21.348 21.348 0 007.51-16.27L505.26 62.82z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconPetitionUpdate = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconPetitionUpdate.defaultProps = {
  theme,
};
IconPetitionUpdate.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconPetitionUpdate.displayName = 'IconPetitionUpdate';
export { IconPetitionUpdate };
